import { FC, MouseEvent } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { useIsLocalEnvironment } from '@telialt/core-eshop/src/hooks/useIsLocalEnvironment';
import { useSelectedProductVariant } from '@telialt/core-eshop/src/hooks/useSelectedProductVariant';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { selectIsSAPOffer, selectSAPOfferCode } from '@telialt/utils/src/eshopSelectors';

import { useBaseProductFromUrlParam } from '../../../hooks/useBaseProductFromUrlParam';
import { ContentWrapper, LocalCodeContent, LocalCodeWrapper } from './LocalCodes.styles';

type Props = {
    label: string;
    code: string;
};

const LocalCode: FC<Props> = ({ label, code }) => {
    const copyToClipboard = (e: MouseEvent<HTMLSpanElement>) => {
        const value = e.currentTarget.textContent;
        navigator.clipboard.writeText(value);
    };

    return (
        <LocalCodeWrapper>
            {label}: <span aria-hidden={true}>(</span>
            <LocalCodeContent onClick={copyToClipboard}>{code}</LocalCodeContent>
            <span aria-hidden={true}>)</span>
        </LocalCodeWrapper>
    );
};

export const LocalCodes = () => {
    const { t } = useTranslations();
    const { baseProduct } = useBaseProductFromUrlParam();
    const { cart } = useCartQuery();

    const productVariant = useSelectedProductVariant();
    const productVariantCode = productVariant?.code;
    const baseProductCode = baseProduct?.code?.replace(/^0+/, '');
    const productVariantScalaId = productVariant?.scalaId;

    const isLocal = useIsLocalEnvironment();
    const sapOfferCode = selectSAPOfferCode(cart);
    const isSAPOffer = selectIsSAPOffer(cart);

    return (
        isLocal && (
            <ContentWrapper data-test={ESHOP_TEST_ID.LOCAL_CODES}>
                {productVariantScalaId && (
                    <LocalCode label={t['eshop.product_page.local.scala_id']} code={productVariantScalaId} />
                )}
                {productVariantCode && (
                    <LocalCode label={t['eshop.product_page.local.variant_product_code']} code={productVariantCode} />
                )}
                {baseProductCode && (
                    <LocalCode label={t['eshop.product_page.local.base_product_code']} code={baseProductCode} />
                )}
                {isSAPOffer && <LocalCode label={t['eshop.product_page.local.sap_offer_code']} code={sapOfferCode} />}
            </ContentWrapper>
        )
    );
};
